import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import { ControlledInput } from "../../../common/Input/Input";
import ModalContent from "../../../common/Modal/ModalContent";
import { X } from "react-feather";
import Checkbox from "../../../common/Checkbox/Checkbox";
import Spinner from "../../../common/Spinner/Spinner";
import SendNeftDetails from './SendNeftDetails'
import close_modal from "../../../assets/ic_close_wh.svg";

Modal.setAppElement("#root");

export default function NeftModal({ neftDetails, ...props }) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="medium-general-modal conv-width-40%">
				<div className="modal-header">
					<span className="modal-title">NEFT Details</span>
					<img
						alt="close"
						id="Close"
						src={close_modal}
						className="close modal-close"
						onClick={props.toggleModal}
					/>
				</div>
				<div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar 
					${props.isDisabled}
					${props.isLoading && "set-opacity"}`}>
					{props.isLoading && <Spinner className="center" />}
					<div className="row conv-mt10">
						<div className="col-12">
							<div className="form-group">
								<ControlledInput
									name="sNEFTDetails2"
									label="NEFT Details"
									value={neftDetails.sNEFTDetails2 || ""}
									onChange={({ target: { name, value } }) =>
										props.onInputChange(name, value)
									}
									onClick={(e) => {
										e.stopPropagation();
									}}
								// required
								/>
							</div>
						</div>
						<div className="col-12">
							<div className="form-group">
								<ControlledInput
									name="sNEFTTxnId"
									label="NEFT Transaction Id"
									value={
										neftDetails.sNEFTTxnId_1 ||
										neftDetails.sNEFTTxnId_2 ||
										""
									}
									placeholder={
										"Only alphanumeric strings are allowed"
									}
									onChange={({ target: { name, value } }) =>
										props.onInputChange(name, value)
									}
									onClick={(e) => {
										e.stopPropagation();
									}}
								// required
								/>
							</div>
						</div>
						<div className="col-12">
							<div className="form-group">
								<ControlledInput
									name="fAmountReceived"
									label="Amount Received"
									type="number"
									value={
										neftDetails.fAmountReceived_1 ||
										neftDetails.fAmountReceived_2 ||
										""
									}
									placeholder={"[in INR] Only numbers are allowed"}
									onChange={({ target: { name, value } }) =>
										props.onInputChange(name, value)
									}
									onClick={(e) => {
										e.stopPropagation();
									}}
									// required
								/>
							</div>
						</div>
						<div className="col-6">
							<div className="lpm-checkbox-label conv-pr5 conv-mr40">
								<Checkbox
									id="NEFT"
									checked={neftDetails.bNEFTPayment || false}
									onChange={(e) => {
										e.stopPropagation();
										props.onInputChange(
											"bNEFTPayment",
											!neftDetails.bNEFTPayment
										);
									}}
									label="NEFT Payment"
									onClick={(e) => {
										e.stopPropagation();
									}}																
								></Checkbox>
							</div>
						</div>
						<div className="col-6">
							<span className="my-services-dnd-link conv-ml40 con-cursor-pointer"
							onClick={() =>
								props.setShowSendNeftDetailsModal(
									!props.showSendNeftDetailsModal,
									props.nResourceInstanceId
								)
							}>Send Neft Details</span>
						</div>
						<div className=" col-12 conv-mt10">
							<button 
								type="button" 
								className={`my-services-model-submit-btn conv-pl25 conv-pr25 conv-mt10`}
								onClick={() =>props.onSaveNeftDetails()}>
								Save
							</button>
							<button 
								type="button" 
								className={`my-services-model-cancel-btn conv-ml25 conv-mt10`}
								onClick={() =>props.toggleModal()}>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</ModalContent>
		</Modal >
	);
}
